import { render, staticRenderFns } from "./TableSwapGroupMembers.vue?vue&type=template&id=08446a24&scoped=true"
import script from "./TableSwapGroupMembers.js?vue&type=script&lang=js&external"
export * from "./TableSwapGroupMembers.js?vue&type=script&lang=js&external"
import style0 from "./TableSwapGroupMembers.vue?vue&type=style&index=0&id=08446a24&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08446a24",
  null
  
)

export default component.exports